import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/tailwind';
const inputVariants = cva(['space-x-2', 'inline-flex', 'bg-white', 'items-center', 'align-middle', 'font-medium', 'border', 'border-gray-300', 'placeholder:text-gray-500', 'focus-within:border-primary'], {
  variants: {
    size: {
      sm: ['px-[10px]', 'h-[36px]', 'rounded-[12px]', 'text-body-2'],
      md: ['px-3', 'h-10', 'rounded-[12px]', 'text-subtitle']
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
export const Input = forwardRef<HTMLInputElement, InputProps>(function InputInner({
  leftSlot,
  rightSlot,
  className,
  size,
  ...props
}, ref) {
  return <div className={cn(inputVariants({
    size
  }), className)}>
        {leftSlot && <span className="text-body-2 whitespace-nowrap !leading-none text-inherit">
            {leftSlot}
          </span>}
        <input type="text" ref={ref} className="w-full bg-transparent text-inherit outline-none" {...props} />
        {rightSlot && <span className="text-body-2 whitespace-nowrap !leading-none text-inherit">
            {rightSlot}
          </span>}
      </div>;
});
type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & VariantProps<typeof inputVariants> & {
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
};